import { AnnuaireDocumentType, EtablissementFichierType, OrganismeFichierType } from '@common/services';

export const ANNUAIRE_DOCUMENT_TYPE_TEXTS: Record<AnnuaireDocumentType, string> = {
  [OrganismeFichierType.HABILITATION]: 'Habilitation',
  [OrganismeFichierType.ATTESTATION_REPRESENTANT]: 'Attestation du représentant',
  [OrganismeFichierType.DELEGATION_POUVOIR]: 'Délégation de pouvoir',
  [EtablissementFichierType.DECLARATION]: 'Déclaration',
  [EtablissementFichierType.ATTESTATION]: 'Attestation',
};